import { Column, Index } from 'typeorm';

import { ApiProperty } from '../../codegen';
import {
  IsDate,
  IsEnum,
  IsNumber,
  IsObject,
  IsOptional,
  IsString,
} from '../../validators';
import { BasicEntity } from '../basic/basic.entity';

import {
  EWithdrawalKycProvider,
  EWithdrawalKycStatus,
} from './withdrawal-kyc.enums';

export class WithdrawalKycPayloadSummaryDto {
  @ApiProperty()
  @IsString({ groups: ['error'] })
  status: string;

  @ApiProperty({ required: false })
  @IsOptional()
  @IsString({ groups: ['error'] })
  code?: string;

  @ApiProperty({ required: false })
  @IsOptional()
  @IsString({ groups: ['error'] })
  reason?: string;

  @ApiProperty({ required: false })
  @IsOptional()
  @IsString({ groups: ['error'] })
  attemptId?: string;

  @ApiProperty({ required: false })
  @IsOptional()
  @IsString({ groups: ['error'] })
  verificationId?: string;
}

@Index(['userId'], { unique: true })
@Index('IDX_billing__withdrawal_kyc__identity_fingerprint_lookup', [
  'fingerprintVersion',
  'identityFingerprintHash',
])
@Index('IDX_billing__withdrawal_kyc__document_fingerprint_lookup', [
  'fingerprintVersion',
  'documentFingerprintHash',
])
export class WithdrawalKyc extends BasicEntity {
  @ApiProperty()
  @IsNumber({}, { groups: ['error'] })
  @Column({ type: 'int', nullable: false })
  userId: number;

  @ApiProperty()
  @IsEnum(EWithdrawalKycProvider, { groups: ['error'] })
  @Column({ type: 'varchar', enum: EWithdrawalKycProvider, nullable: false })
  provider: EWithdrawalKycProvider;

  @ApiProperty()
  @IsEnum(EWithdrawalKycStatus, { groups: ['error'] })
  @Column({ type: 'varchar', enum: EWithdrawalKycStatus, nullable: false })
  status: EWithdrawalKycStatus;

  @ApiProperty({ required: false })
  @IsOptional()
  @IsString({ groups: ['error'] })
  @Column({ type: 'varchar', nullable: true })
  providerVerificationId?: string | null;

  @ApiProperty({ required: false })
  @IsOptional()
  @IsString({ groups: ['error'] })
  @Column({ type: 'text', nullable: true })
  providerSessionToken?: string | null;

  @ApiProperty({ required: false })
  @IsOptional()
  @IsString({ groups: ['error'] })
  @Column({ type: 'varchar', nullable: true })
  providerAttemptId?: string | null;

  @ApiProperty({ required: false })
  @IsOptional()
  @IsString({ groups: ['error'] })
  @Column({ type: 'text', nullable: true })
  verificationUrl?: string | null;

  @ApiProperty({ required: false })
  @IsOptional()
  @IsString({ groups: ['error'] })
  @Column({ type: 'varchar', nullable: true })
  vendorData?: string | null;

  @ApiProperty({ required: false })
  @IsOptional()
  @IsString({ groups: ['error'] })
  @Column({ type: 'varchar', nullable: true })
  endUserId?: string | null;

  @ApiProperty({ required: false })
  @IsOptional()
  @IsString({ groups: ['error'] })
  @Column({ type: 'varchar', nullable: true })
  decisionCode?: string | null;

  @ApiProperty({ required: false })
  @IsOptional()
  @IsString({ groups: ['error'] })
  @Column({ type: 'text', nullable: true })
  decisionReason?: string | null;

  @ApiProperty({ required: false })
  @IsOptional()
  @IsString({ groups: ['error'] })
  @Column({ type: 'varchar', length: 64, nullable: true })
  identityFingerprintHash?: string | null;

  @ApiProperty({ required: false })
  @IsOptional()
  @IsString({ groups: ['error'] })
  @Column({ type: 'varchar', length: 64, nullable: true })
  documentFingerprintHash?: string | null;

  @ApiProperty({ required: false })
  @IsOptional()
  @IsNumber({}, { groups: ['error'] })
  @Column({ type: 'int', nullable: true })
  fingerprintVersion?: number | null;

  @ApiProperty({ required: false })
  @IsOptional()
  @IsDate({ groups: ['error'] })
  @Column({ type: 'timestamptz', nullable: true, precision: 3 })
  approvedAt?: Date | null;

  @ApiProperty({ required: false })
  @IsOptional()
  @IsDate({ groups: ['error'] })
  @Column({ type: 'timestamptz', nullable: true, precision: 3 })
  decisionAt?: Date | null;

  @ApiProperty({ required: false })
  @IsOptional()
  @IsDate({ groups: ['error'] })
  @Column({ type: 'timestamptz', nullable: true, precision: 3 })
  lastWebhookAt?: Date | null;

  @ApiProperty({ required: false })
  @IsOptional()
  @IsObject({ groups: ['error'] })
  @Column({ type: 'jsonb', nullable: true })
  payloadSummary?: WithdrawalKycPayloadSummaryDto | null;
}
